import React, { useState } from 'react';
import { Box, Grid, Link, Typography, IconButton, Tooltip } from '@mui/material';
import ContentCopy from '@mui/icons-material/ContentCopy';
import OpenInNew from '@mui/icons-material/OpenInNew';
import Check from '@mui/icons-material/Check';

const ActionsContainer = ({ url, isDisabled, showLink = false, showLiveButton = true }) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopyLink = () => {
        navigator.clipboard
            .writeText(url)
            .then(() => {
                setIsCopied(true);
                setTimeout(() => setIsCopied(false), 3000); // Reset copied state after 3 seconds
            })
            .catch((err) => console.error('Failed to copy the link:', err));
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
            {/* Display the URL on the left */}
            {showLink && (
                <Typography variant="body1" sx={{ maxWidth: 'calc(100% - 8px)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    <Link
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            textDecoration: 'none',
                            color: '#003366', // Standard vibrant blue color (similar to the one in the image)
                        }}
                    >
                        {url}
                    </Link>
                </Typography>
            )}

            {/* Action Buttons for Copy and View on the right */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginLeft: 'auto' }}>
                {/* Copy Link Button */}
                <Tooltip title="Copy link" arrow>
                    <IconButton onClick={handleCopyLink} color="primary">
                        <ContentCopy fontSize="small" />
                    </IconButton>
                </Tooltip>
                {isCopied && (
                    <Typography variant="caption" color="success.main" sx={{ marginTop: 0.5 }}>
                        <Check fontSize="small" sx={{ verticalAlign: 'middle' }} /> Copied
                    </Typography>
                )}

                {/* Open in New Tab Button */}
                {showLiveButton && (
                    <Tooltip title="Open link in new tab" arrow>
                        <IconButton
                            href={url}
                            target="_blank"
                            rel="noopener"
                            size="small"
                            color="primary"
                        >
                            <OpenInNew fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}

            </Box>
        </Box>
    );
};

export default ActionsContainer;
